export default function priceFormat(value: number): string {
  if (value == null) {
    return '';
  }
  return value.toLocaleString('ja-JP', {style: 'currency', currency: 'JPY', maximumFractionDigits: 3});
}
